if (!window.customElements.get('studio-reveal-observer')) {
  class StudioRevealObserver extends HTMLElement {
    connectedCallback() {
      const targets = this.querySelectorAll('.studio-reveal');

      if (!('IntersectionObserver' in window) || targets.length === 0) {
        targets.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
      );

      targets.forEach((el) => observer.observe(el));
    }
  }

  window.customElements.define('studio-reveal-observer', StudioRevealObserver);
}
